export const appointments = [
  {
    id: 1,
    type: "Dentist",
    time: "09:00-11:00",
    doctor: "Dr. Cameron Williamson",
    icon: "🦷",
    bgColor: "bg-indigo-800",
    textColor: "text-white",
  },
  {
    id: 2,
    type: "Physiotherapy Appointment",
    time: "11:00-12:00",
    doctor: "Dr. Kevin Djones",
    icon: "💪",
    bgColor: "bg-indigo-100",
    textColor: "text-indigo-900",
  },
];